import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsCreateArticleRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-create-article',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId/space/:spaceKey/edit',
	query: ['draftShareId?', 'topicId?'],
};
